import clsx from "clsx";

export function DetailGridValue({
    isLoading,
    value,
    onClick,
}: {
    isLoading: boolean;
    value?: string;
    onClick?: () => void;
}) {
    if (isLoading) {
        return (
            <div className="flex size-full items-center">
                <div
                    className={clsx(
                        "h-5 w-full bg-slate-700",
                        "animate-pulse rounded",
                    )}
                />
            </div>
        );
    }

    return (
        <span
            className={clsx(
                "w-full",
                "body-s cursor-pointer break-words text-left",
            )}
            onClick={onClick}
        >
            {value ? value : "-"}
        </span>
    );
}
